import {Directive, Input, Output, ElementRef, EventEmitter} from '@angular/core';

import 'jquery-slimscroll';

declare var $: any;

@Directive({
  selector: '[UbiSlimScroll]'
})
export class UbiSlimScroll {

  @Input() public UbiSlimScrollOptions: Object;

  constructor(private _elementRef: ElementRef) {
  }

  ngOnChanges(changes) {
    this._scroll();
  }

  private _scroll() {
    this._destroy();
    this._init();
  }

  private _init() {
    $(this._elementRef.nativeElement).slimScroll(this.UbiSlimScrollOptions);
  }

  private _destroy() {
    $(this._elementRef.nativeElement).slimScroll({ destroy: true });
  }
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/directives/ubiSlimScroll/ubiSlimScroll.directive.ts